import { flatObjectAll } from '../../script.js'

// 新添加的所有翻译必须前面加字母   n   

const language = {
  assets: {},
  components: {
    amap: {

    },
    basics: {

    },
    device: {

    },
    explorer: {

    },
    home: {
      index: {
        nhi01: {
          zh: "播放时间点",
          en: "Play time point",
          vi: "Chơi thời gian",
          ru: "Точка времени проигрывания",
        },
        nhi02: {
          zh: "播放设备",
          en: "Play back equipment",
          vi: "Chơi thiết bị",
          ru: "Проигрыватель.",
        },
      }
    },
    log: {

    },
    login: {

    },
    manage: {

    },
    review: {

    },
    schedule: {
      windows: {
        children: {
          TerminalList: {
            nswct01: {
              zh: "播单名称",
              en: "Name of cast order",
              vi: "Đĩa đơn tên",
              ru: "Одно имя для передачи",
            },
            nswct02: {
              zh: "请输入播单名称",
              en: "Please enter the cast name",
              vi: "Hãy nhập tên đĩa đơn",
              ru: "Введите, пожалуйста, название канала",
            }
          }
        }
      }
    },
    system: {
      TemplateManagement: {}
    },
    terminal: {
      children: {
        HandleOrder: {
          ntch01: {
            zh: "流地址",
            en: "Address of stream",
            vi: "Địa chỉ dòng",
            ru: "Адрес потока",
          }
        }
      }
    },
  },
  router: {
    index: {
      ritm: {
        zh: "模板管理",
        en: "Template management",
        vi: "Quản lý mẫu",
        ru: "Управление шаблонами",
      }
    }
  },
  views: {},
  App: {
  },
  srcStatic: {
    data: {
      contentBtnList: {
        ssdcbl1: {
          zh: "上传日志",
          en: "Upload log",
          vi: "Tải lên một bản ghi",
          ru: "Загрузка.",
        },
        ssdcbl2: {
          zh: "添加流媒体",
          en: "Add streaming media",
          vi: "Thêm truyền thông trực tiếp",
          ru: "Добавлять поток",
        },
        ssdcbl3: {
          zh: "播表撤回",
          en: "Broadcast table withdrawal",
          vi: "Chơi bảng rút lui",
          ru: "Отбой.",
        },
        ssdcbl4: {
          zh: "终端导出",
          en: "Terminal export",
          vi: "Xuất khẩu thiết bị đầu cuối",
          ru: "Выход из терминала",
        },
        ssdcbl5: {
          zh: "更多控制",
          en: "More Control",
          vi: "Kiểm soát nhiều hơn",
          ru: "Больше контроля.",
        }
      }
    }
  }
}


const object = flatObjectAll(language);
const languages = { zh: {}, en: {}, vi: {}, ru: {} };

for (const key in object) {
  if (Object.hasOwnProperty.call(object, key)) {
    const { zh, en, vi, ru } = object[key];
    languages['zh'][key] = zh;
    languages['en'][key] = en;
    languages['vi'][key] = vi;
    languages['ru'][key] = ru;
  }
}

export default languages;